import { addFollow, FollowButton, withFollow } from '@eb/follow-organizer-ebui';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { AppProps, GASettings, Organizer } from '../../types';
import { dynaMount } from '../utils/mountComponent';

interface OrganizerData extends Organizer {
    followedByYou: boolean;
    numFollowers?: number;
    numUpcomingEvents?: number;
}
export interface FollowOrganizerProps {
    gaSettings: GASettings;
    gaCategory: string;
    organizers: string[];
    isAuthenticated?: boolean;
    userId?: string;
    size?: string;
    isGDPRCountry?: boolean;
    organizerData?: {
        [key: string]: OrganizerData;
    };
}

const FOLLOW_ORGANIZER_MINI_SIZE = 'mini';
const FOLLOW_ORGANIZER_HERO_ID = 'listings-root__follow-organizer_hero';
const FOLLOW_ORGANIZER_ORG_PANEL_ID =
    'listings-root__follow-organizer_org-panel';
const FOLLOW_ORGANIZER_EXPIRED_ID = 'listings-root__follow-organizer_expired';

const getFollowOrganizerProps = (props: AppProps): FollowOrganizerProps => {
    const {
        components: { followOrganizer },
        gaSettings,
        user: { isAuthenticated, id: userId },
        organizer: {
            id: orgId,
            name: orgName,
            url: orgUrl,
            profilePicture: orgLogo,
        },
    } = props;

    return {
        ...followOrganizer,
        gaSettings,
        gaCategory: gaSettings.category,
        isAuthenticated,
        organizers: [orgId],
        organizerData: {
            [orgId]: {
                id: orgId,
                name: orgName,
                url: orgUrl,
                profilePicture: orgLogo,
                followedByYou: false,
            },
        },
        userId: `${userId}`,
    };
};

const EnhancedFollowButtton = withFollow(FollowButton);

const FollowOrganizerWidget: React.FunctionComponent<FollowOrganizerProps> = (
    props,
) => {
    const { organizers, size } = props;

    return (
        <EnhancedFollowButtton
            isOnlyButton={true}
            organizerId={organizers[0]}
            size={size}
        />
    );
};

const FollowOrganizerHero = (props: FollowOrganizerProps) =>
    dynaMount(
        {
            Component: FollowOrganizerWidget,
            containerId: FOLLOW_ORGANIZER_HERO_ID,
        },
        { ...props, size: FOLLOW_ORGANIZER_MINI_SIZE },
    );

const FollowOrganizerOrgPanel = (props: FollowOrganizerProps) =>
    dynaMount(
        {
            Component: FollowOrganizerWidget,
            containerId: FOLLOW_ORGANIZER_ORG_PANEL_ID,
        },
        props,
    );

const FollowOrganizerExpired = (props: FollowOrganizerProps) =>
    dynaMount(
        {
            Component: FollowOrganizerWidget,
            containerId: FOLLOW_ORGANIZER_EXPIRED_ID,
        },
        props,
    );

const FollowOrganizerMount = (props: FollowOrganizerProps): JSX.Element => (
    <>
        <FollowOrganizerHero {...props} />
        <FollowOrganizerOrgPanel {...props} />
        <FollowOrganizerExpired {...props} />
    </>
);

const FollowOrganizerRoot = (props: AppProps): JSX.Element | null => {
    if (isEmpty(props.organizer)) {
        return null;
    }
    const followOrganizerProps = getFollowOrganizerProps(props);
    const EnhancedFollowOrganizer = addFollow(() => (
        <FollowOrganizerMount {...followOrganizerProps} />
    ));

    return <EnhancedFollowOrganizer {...followOrganizerProps} />;
};

export default FollowOrganizerRoot;
